// Import 3rd-party dependencies
import { Component, Input } from '@angular/core';

// Import project-specific dependencies
import { FOOTER_COMPONENT_CONSTS } from '@app/config/constants';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent {
  @Input() logo: string;
  consts = FOOTER_COMPONENT_CONSTS;

  constructor() {}
}
